import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './CommunicationEvaluationGraphsScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Spin, Table, Form, Select, DatePicker, Icon } from 'antd';
import { Grid } from '@material-ui/core';
import { employeeById } from 'app/reducers';
import TextInput from '../../../app/components/TextInput';
import { debounce } from 'debounce';
import ApiService from 'app/services/ApiService';
import moment from 'moment';
import Chart from 'react-google-charts';
import html2pdf from 'html2pdf.js'

const { RangePicker } = DatePicker;

const CommunicationEvaluationGraphsScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);
    const [filterdata, setFilterData] = useState({})
    const [contrato, setContrato] = useState("");
    const [procedure, setProcedure] = useState("");
    const [titleGraphic, setTitleGraphic] = useState("")
    const [date, setDate] = useState([])
    const [verGrafica, setVerGrafica] = useState(false)
    //const info = [['Fecha', 'Comunicación', 'Evaluación']];
    const [info, setInfo] = useState([]);
    const [dateTicks, setDateTicks] = useState([]);
    const [info1, setInfo1] = useState([]);
    const [info2, setInfo2] = useState([]);
    const [nombre, setNommbre] = useState("");

    const [exporting, setExporting] = useState(false);

    useEffect(() => {
        getFilters();
    }, []);

    const getFilters = () => {
        ApiService.getEvaluationsFilters().then(
            (response) => {
                setFilterData(response.data);
            }
        )
    }

    const getInfoGraphs = () => {
        setTitleGraphic(contrato == "" ? "" : filterdata.contracts?.filter(x => x.idContract == contrato)[0].contractName);
        var payload = {
            IdContract: contrato,
            // IdCourse: procedure,
            DateStart: moment(date[0]).format('YYYY-MM-DD'),
            DateEnd: moment(date[1]).format('YYYY-MM-DD'),
        }
        ApiService.getEvaluationsContracts(payload).then(
            (response) => {

                let { listData } = response;
                let info_ = [];
                let info1_ = [];
                let info2_ = [];
                let dateTicks_ = []
                for (var i = 0; i < listData.length; i++) {

                    var dateParts = listData[i].fecha.split("/");
                    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

                    dateTicks_.push(dateObject)
                    info_.push([dateObject, listData[i].comunicaciones, listData[i].evaluaciones])

                    info1_.push([dateObject, listData[i].comunicaciones]);
                    info2_.push([dateObject, listData[i].evaluaciones]);
                }

                setInfo(info_)
                setInfo1(info1_)
                setInfo2(info2_)
                setDateTicks(dateTicks_);
                setVerGrafica(true);
            }
        )
    }

    const cleanAll = () => {
        setInfo([])
        setInfo1([])
        setInfo2([])
        setDateTicks([]);
        //setVerGrafica(false);
        setContrato("");
        setProcedure("");
        setDate([]);
    }

    const optionContracts = filterdata.contracts?.map((item) =>
        <Select.Option key={item.idContract} value={item.idContract}>{item.contractName}</Select.Option>
    );

    const optionProcedures = filterdata.courses?.map((item) =>
        <Select.Option key={item.idCourse} value={item.idCourse}>{item.courseName}</Select.Option>
    );

    function checkDate(value, value2) {
        var currentDate = moment(value[0]);
        var endDate = moment(value[1]);
        var futureYear = moment(currentDate).add(1, 'Y');
        const diff = endDate.diff(currentDate, 'years'); 
       if (value[0] !== "")
       setDate([value[0], diff > 0 ?  futureYear : value[1]])
   else 
       setDate([null,null])
    }

    const divGraphs = ()=>{
        let initialLetter = 'reactgooglegraph-';
        let contador = 0;
        let divG = null;
        do{
            
            divG = document.getElementById(initialLetter+contador.toString());
            contador++;
        } while(divG == null);

        return divG;
    }

    const exportGraphs = async () => {
        setExporting(true);
        var element = divGraphs();

        var element2 = document.getElementById('graphs2');
        // var element3 = document.getElementById('reactgooglegraph-3');

        // element2.appendChild(element3.cloneNode(true));
        var element_width = element2.offsetWidth;

        var opt = {
            margin: 1,
            filename: `${titleGraphic}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, width: element_width  },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
        };

        // New Promise-based usage:
        //await html2pdf().set(opt).from(element).save();


        let doc = html2pdf().set(opt).from(element).toPdf()

        doc = doc.get('pdf').then(
            pdf => { pdf.addPage() }
        ).from(element2).toContainer().toCanvas().toPdf()

        // doc = doc.get('pdf').then(
        //     pdf => { pdf.addPage() }
        // ).from(element3).toContainer().toCanvas().toPdf()

        await doc.save()

        //element2.removeChild(document.getElementById("reactgooglegraph-2").lastElementChild)
        setExporting(false);
    }

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isGraph={true} header='Cumplimiento Programa de Comunicación vs Evaluaciones por Contrato' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Gráficas
                        </Link>
                        <TextEvents
                            text="Cumplimiento Programa de Comunicación vs Evaluaciones por Contrato"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                    <Paper className={classes.rootPaper}>
                        <div>
                            <Grid container direction="row" spacing={2}>
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Contrato:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        placeholder="[Selecionar Contrato]"
                                        showSearch
                                        value={contrato}
                                        onChange={setContrato}
                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                        optionFilterProp="Children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        mode="single"
                                    >
                                        {optionContracts}
                                    </Select>
                                </Grid>
                                {/* <Grid item xs={4}>
                                    <TextEvents
                                        text='Procedimiento:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <Select
                                        placeholder="[Selecionar Procedimiento]"
                                        showSearch
                                        value={procedure}
                                        onChange={setProcedure}
                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                        optionFilterProp="Children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        mode="single"
                                    >
                                        {optionProcedures}
                                    </Select>
                                </Grid> */}
                                <Grid item xs={6}>
                                    <TextEvents
                                        text='Rango de Fechas:'
                                        color="darker"
                                        size='label'
                                        weight="medium"
                                    />
                                    <RangePicker
                                        placeholder={['Fecha inicial', 'Fecha final']}
                                        format="YYYY-MM-DD"
                                        onChange={checkDate}
                                        value={date}
                                    />

                                </Grid>
                            </Grid>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                <Button
                                    className={classes.button}

                                    variant="contained"
                                    type="primary"
                                    onClick={cleanAll}
                                >
                                    Limpiar
                                </Button>
                                <Button
                                    className={classes.button}
                                    disabled={contrato === "" || date.length === 0}
                                    variant="contained"
                                    type="primary"
                                    onClick={getInfoGraphs}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    disabled={!verGrafica}
                                    variant="contained"
                                    type="primary"
                                    onClick={exportGraphs}
                                    loading={exporting}
                                >
                                    Exportar
                                </Button>
                            </div>
                            <Grid container direction="row" spacing={2}>
                                <Grid item xs={6}>
                                    {verGrafica ? <Chart
                                        chartType={"LineChart"}
                                        loader={<div><Icon type="loading" />Cargando...</div>}
                                        rows={info}
                                        height={'60vh'}
                                        width={'100vh'}
                                        options={{
                                            title: titleGraphic,
                                            hAxis: {
                                                title: "Fecha",
                                                format: "dd-MM-yyyy",
                                                ticks: dateTicks,
                                            },
                                            vAxis: {
                                                title: "Número de comunicaciones vs evaluaciones",
                                            },
                                            legend: { position: 'top', alignment: 'center' },

                                        }}
                                        columns={[
                                            { type: "date", label: "Fecha" },
                                            { type: "number", label: "Comunicación" },
                                            { type: "number", label: "Evaluación" }
                                        ]}
                                    /> : null}

                                </Grid>
                                <Grid item xs={6}>
                                    <div id="graphs2">
                                        <Grid container direction="row" spacing={2}>
                                            <Grid item xs={12}>
                                                {verGrafica ? <Chart
                                                    chartType={"LineChart"}
                                                    loader={<div><Icon type="loading" />Cargando...</div>}
                                                    rows={info1}
                                                    height={'30vh'}
                                                    width={'100vh'}
                                                    options={{
                                                        title: titleGraphic,
                                                        hAxis: {
                                                            title: "Fecha",
                                                            format: "dd-MM-yyyy",
                                                            ticks: dateTicks,
                                                        },
                                                        vAxis: {
                                                            title: "Número de comunicaciones",
                                                        },
                                                        legend: { position: 'top', alignment: 'center' },

                                                    }}
                                                    columns={[
                                                        { type: "date", label: "Fecha" },
                                                        { type: "number", label: "Comunicación" }
                                                    ]}
                                                /> : null}
                                            </Grid>
                                            <Grid item xs={12}>
                                                {verGrafica ? <Chart
                                                    chartType={"LineChart"}
                                                    loader={<div><Icon type="loading" />Cargando...</div>}
                                                    rows={info2}
                                                    height={'30vh'}
                                                    width={'100vh'}
                                                    options={{
                                                        title: titleGraphic,
                                                        hAxis: {
                                                            title: "Fecha",
                                                            format: "dd-MM-yyyy",
                                                            ticks: dateTicks,
                                                        },
                                                        vAxis: {
                                                            title: "Número de evaluaciones",
                                                        },
                                                        series: {
                                                            0: { color: '#e2431e' },
                                                        },
                                                        legend: { position: 'top', alignment: 'center' },

                                                    }}
                                                    columns={[
                                                        { type: "date", label: "Fecha" },
                                                        { type: "number", label: "Evaluación" }
                                                    ]}
                                                /> : null}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                </div>

            </div>
        </div>
    )
}
export default CommunicationEvaluationGraphsScreen;